module.exports = __webpack_public_path__ + "img/symbol_2.39e2cfe4.png";